// extracted by mini-css-extract-plugin
export var Sidebar = "Sidebar-module--Sidebar--cdede";